import { PropsWithChildren } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

export type BadgeVariant = 'primary' | 'success' | 'warning' | 'danger' | 'muted'

type BadgeProps = WithClassName<
	PropsWithChildren<{
		variant?: BadgeVariant
		uppercase?: boolean
		prefix?: string
		dot?: boolean
		dotSize?: 'sm' | 'md'
	}>
>

const variantClassNames: Record<BadgeVariant, string> = {
	primary: 'bg-primary-soft text-primary',
	success: 'bg-success-soft text-success',
	warning: 'bg-warning-soft text-warning',
	danger: 'bg-danger-soft text-danger',
	muted: 'bg-muted text-muted-foreground'
}

export const Badge = ({
	variant = 'primary',
	uppercase = false,
	prefix,
	dot = true,
	dotSize = 'md',
	className,
	children
}: BadgeProps) => (
	<span
		className={cn(
			'inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-1 text-[10px] font-semibold',
			variantClassNames[variant],
			uppercase && 'px-2.5 font-bold uppercase tracking-wider',
			className
		)}>
		{prefix && (
			<span className="text-[9px] font-semibold uppercase tracking-wider opacity-60">{prefix}</span>
		)}
		{dot && (
			<span
				className={cn(
					'shrink-0 rounded-full bg-current',
					dotSize === 'sm' ? 'h-1 w-1' : 'h-1.5 w-1.5'
				)}
			/>
		)}
		{children}
	</span>
)
